module.exports = __webpack_public_path__ + "img/arrow-share.f7373727.png";